import { useId } from 'react'

import { ColorVariant, CornerRadius, Drawer, FormContainer } from '@makyoapp/makyo-tw-ui'

import { useBuilderColorSchemeV2 } from '@/hooks/__project__/useBuilderColorSchemeV2'
import { useActiveDevice } from '@/hooks/useActiveDevice'

const cornerRadiusMap = {
  phone: 'large',
  'phone-landscape': 'large',
  tablet: 'large',
  'tablet-landscape': 'none',
  desktop: 'none',
  tv: 'none',
}

const placementMap = {
  phone: 'bottom',
  'phone-landscape': 'bottom',
  tablet: 'bottom',
  'tablet-landscape': 'left',
  desktop: 'left',
  tv: 'left',
}

const maxHeightMap = {
  phone: 'calc(100% - 1rem)',
  'phone-landscape': 'calc(100% - 1rem)',
  tablet: 'calc(100% - 1rem)',
  'tablet-landscape': '100%',
  desktop: '100%',
  tv: '100%',
}

const sizeMap = {
  phone: 'auto,100%',
  'phone-landscape': 'auto,100%',
  tablet: 'auto,100%',
  'tablet-landscape': '35%,100%',
  desktop: '30%,100%',
  tv: '30%,100%',
}

interface CompFilterDrawerProps {
  onClose: () => void
  open: boolean
  children: React.ReactNode
  title?: React.ReactNode
  bgColor?: ColorVariant
}

export const FilterDrawer = ({ onClose, open, children, title, bgColor = 'primary-95' }: CompFilterDrawerProps) => {
  const customId = useId()
  const [colorScheme] = useBuilderColorSchemeV2()
  const [device] = useActiveDevice()

  if (!open) return null

  return (
    <Drawer
      id={`filter-drawer-${customId}`}
      open={open}
      onClose={onClose}
      closeOnOverlayClick={true}
      size={sizeMap[device]}
      placement={placementMap[device] as any}
      cornerRadius={cornerRadiusMap[device] as CornerRadius}
      maxHeight={maxHeightMap[device]}
      bgColor={bgColor}
      backdropOpacity={0.7}
      backdropColor={colorScheme.current === 'dark' ? 'neutral-100' : 'neutral-0'}
      title={title}
    >
      <FormContainer backgroundColor={bgColor} className='px-1 py-4 h-full overflow-hidden'>
        {children}
      </FormContainer>
    </Drawer>
  )
}
